import { apiSlice } from '@services/apiSlice';
import { Breadcrumb as endpoints } from '@services/endpoints';
import { Breadcrumb } from './HeaderBar.types';

const breadcrumbApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    fetchBreadcrumb: build.query<Breadcrumb, void>({
      query: () => ({
        url: endpoints.fetchBreadcrumb,
        params: { language: window.lang, pageId: window.pageId }
      }),
    }),
  }),
  overrideExisting: false,
})

export const { useFetchBreadcrumbQuery } = breadcrumbApi;